import { Logo1Dark } from '@blocksuite-local/icons/auto/24/rc';
import { Logo1White } from '@blocksuite-local/icons/auto/24/rc';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

export const ThemedLogo = () => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  console.log({ resolvedTheme });
  // After mounting, we have access to the theme
  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return null;
  }

  return resolvedTheme === 'dark' ? (
    <Logo1White className="logo" />
  ) : (
    <Logo1Dark className="logo" />
  );
};
